module.exports = __webpack_public_path__ + "img/empresa.3cc2cb77.svg";